import { render, staticRenderFns } from "./DisableNotificationNeuerBesuchsbericht.vue?vue&type=template&id=0f0f4b86"
import script from "./DisableNotificationNeuerBesuchsbericht.vue?vue&type=script&lang=js"
export * from "./DisableNotificationNeuerBesuchsbericht.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports